import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import locations from "../../locations/locations";
import { StyledLocationFilters } from "./location-filters.scss";
import Dropdown from "../dropdown/dropdown";
import classnames from "classnames";
import { getLocationID } from "components/pages/careers/careers-service";
import { useCallback, useMemo } from "react";
const LOCATION_TITLE = "All Locations";
const LOCATION_DROPDOWN_TITLE = "Choose your favorite location";
const LocationFilters = ({ onLocationChange, selectedLocationId, positionsPerLocation })=>{
    const reset = useCallback(()=>onLocationChange(null), [
        onLocationChange
    ]);
    const handleDropdownOptionKeyPress = (event, onChangeFunc)=>event.key === "Enter" && onChangeFunc();
    const selectedLocation = useMemo(()=>locations.find((location1)=>location1.id === selectedLocationId), [
        selectedLocationId
    ]);
    const getNumberOfPositions = (locationId)=>{
        const locationKey = Object.keys(positionsPerLocation).find((locationComeetName)=>getLocationID(locationComeetName) === locationId);
        return positionsPerLocation[locationKey] || 0;
    };
    const itemRenderer = ({ Icon, name, id })=>{
        const locationID = getLocationID(name);
        const numberOfPositions = getNumberOfPositions(locationID);
        return /*#__PURE__*/ _jsxs("a", {
            tabIndex: "0",
            className: classnames("location-item", {
                "is-active": (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.id) === locationID
            }),
            onClick: ()=>onLocationChange(id),
            onKeyPress: (event)=>handleDropdownOptionKeyPress(event, ()=>onLocationChange(location.id)),
            children: [
                /*#__PURE__*/ _jsx(Icon, {}),
                /*#__PURE__*/ _jsxs("div", {
                    className: "details",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "location",
                            children: name
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "number-of-positions",
                            children: [
                                numberOfPositions,
                                " ",
                                numberOfPositions === 1 ? "position" : "positions"
                            ]
                        })
                    ]
                })
            ]
        }, locationID);
    };
    return /*#__PURE__*/ _jsx(StyledLocationFilters, {
        children: /*#__PURE__*/ _jsx(Dropdown, {
            reset: reset,
            dropdownTitle: LOCATION_DROPDOWN_TITLE,
            title: LOCATION_TITLE,
            items: locations,
            selectedItem: selectedLocation,
            itemRenderer: itemRenderer
        })
    });
};
export default LocationFilters;
